<template>
  <div>
    <app-collapse accordion>
      <app-collapse-item class="border rounded my-2">
        <template #header>
          <BRow class="d-flex w-100 justify-content-between align-items-center">
            <BCol>{{ info.title_ar }}</BCol>
            <BCol class="mb-0 d-flex justify-content-center">
              <div>
                <feather-icon size="15" icon="CalendarIcon" class="mx-1" />
                {{ info.from_event_duration }}
              </div>
            </BCol>
            <BCol>
              <div class="d-flex justify-content-end">
                <b-button
                  v-can="{ slug: $route.meta.slug, action: 'U' }"
                  @click="$emit('editClicked', info)"
                  variant="flat-primary"
                  class="btn-icon rounded-circle"
                >
                  <feather-icon size="15" icon="EditIcon" />
                </b-button>
                <b-button
                  v-can="{ slug: $route.meta.slug, action: 'D' }"
                  @click="onDeleteClicked"
                  variant="flat-danger"
                  class="btn-icon rounded-circle"
                >
                  <feather-icon size="15" icon="Trash2Icon" />
                </b-button>
              </div>
            </BCol>
          </BRow>
        </template>
        <b-row>
          <b-col cols="4">
            <b-img
              :src="info.image_event"
              alt="events"
              style="width: 100%; max-height: 200px; object-fit: cover"
            />
          </b-col>
          <b-col cols="4">
            <b-media no-body class="mb-1 b-flex align-items-center">
              <b-media-aside class="mr-1">
                <b-avatar rounded variant="light-primary" size="34">
                  <feather-icon icon="GridIcon" size="18" />
                </b-avatar>
              </b-media-aside>
              <b-media-body>
                <h6 class="mb-0">النوع : {{ info.eventType.title_ar }}</h6>
              </b-media-body>
            </b-media>

            <b-media no-body class="mb-1 b-flex align-items-center">
              <b-media-aside class="mr-1">
                <b-avatar rounded variant="light-primary" size="34">
                  <feather-icon icon="ClockIcon" size="18" />
                </b-avatar>
              </b-media-aside>
              <b-media-body>
                <b-media-body>
                  <h6 class="mb-0">
                    {{ info.from_event_duration }}
                  </h6>
                  <small>
                    من <span>{{ info.from_time.slice(0, 5) }}</span>
                  </small>
                  <small class="mx-50">إلى</small>
                  <small
                    ><span>{{ info.to_time.slice(0, 5) }}</span></small
                  >
                </b-media-body>
              </b-media-body>
            </b-media>

            <b-media no-body class="mb-1 b-flex align-items-center">
              <b-media-aside class="mr-1">
                <b-avatar rounded variant="light-primary" size="34">
                  <feather-icon icon="UsersIcon" size="18" />
                </b-avatar>
              </b-media-aside>
              <b-media-body>
                الدعوة : {{ info.invitation_type ? "عامة" : "خاصة" }}
              </b-media-body>
            </b-media>

            <b-media no-body class="mb-1 b-flex align-items-center">
              <b-media-aside class="mr-1">
                <b-avatar rounded variant="light-primary" size="34">
                  <feather-icon icon="MapPinIcon" size="18" />
                </b-avatar>
              </b-media-aside>
              <b-media-body>
                <h6 class="mb-0">
                  {{ info.governorate ? info.governorate.name_ar : "" }}
                </h6>
                <small>{{ info.location }}</small>
              </b-media-body>
            </b-media>
          </b-col>
          <b-col cols="4">
            <div style="margin-top: 20px">
              <app-timeline>
                <app-timeline-item
                  title="تاريخ بداية النشاط"
                  :subtitle="info.from_event_duration"
                  variant="success"
                />
                <app-timeline-item
                  title="تاريخ نهاية النشاط"
                  :subtitle="info.to_event_duration"
                  variant="info"
                />
              </app-timeline>
            </div>
            <div></div>
          </b-col>
          <b-col class="mt-1" cols="12">
            <b-card-text>
              <h3 class="mb-1">التفاصيل</h3>
              <p class="mx-1 text-justify">
                {{ info.description_ar }}
              </p>
            </b-card-text>
          </b-col>
        </b-row>
      </app-collapse-item>
    </app-collapse>
  </div>
</template>

<script>
import {
  BCard,
  BImg,
  BButton,
  BRow,
  BCol,
  BFormRadioGroup,
  BFormGroup,
  BFormInput,
  BMedia,
  BMediaAside,
  BAvatar,
  BMediaBody,
  BCardText,
  BModal,
} from "bootstrap-vue";
import AppTimeline from "@core/components/app-timeline/AppTimeline.vue";
import AppTimelineItem from "@core/components/app-timeline/AppTimelineItem.vue";
import Cleave from "vue-cleave-component";
import AppCollapse from "@core/components/app-collapse/AppCollapse.vue";
import AppCollapseItem from "@core/components/app-collapse/AppCollapseItem.vue";
export default {
  props: {
    info: Object,
    page: Number,
  },
  components: {
    BCard,
    BImg,
    BButton,
    AppCollapse,
    AppCollapseItem,
    BRow,
    BCol,
    BFormRadioGroup,
    BFormGroup,
    BFormInput,
    Cleave,
    BMedia,
    BMediaAside,
    BAvatar,
    BMediaBody,
    AppTimeline,
    AppTimelineItem,
    BCardText,
    BModal,
  },
  methods: {
    onDeleteClicked() {
      this.$bvModal
        .msgBoxConfirm("هل أنت متأكد من حذف الفعالية؟", {
          title: "تأكيد حذف الفعالية",
          size: "sm",
          okVariant: "danger",
          okTitle: "تأكيد",
          cancelTitle: "إلغاء",
          cancelVariant: "outline-secondary",
          hideHeaderClose: false,
          centered: true,
        })
        .then(async (value) => {
          if (value) this.$emit("deleteClicked");
        });
    },
  },
};
</script>
